module.exports = __webpack_public_path__ + "img/tiktok.4d86f17e.svg";